import { useState, useEffect } from "react";
import profileApi from "api/profile";
import useNotify from "hooks/useNotify";
import { actions } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { scrollIntoView } from "utils/helper";
import { useTranslation } from "react-i18next";
import { sampleOfWorkType } from "utils/constantValues";

function useRelevantProfile({ profileCompletionRef = {} }) {
  const dispatch = useDispatch();
  const userDetails = useSelector((state) => state.userDetails || {});

  const currentSampleOfWorkIds =
    userDetails?.userFiles
      ?.filter((file) => file.type === sampleOfWorkType)
      ?.map((file) => file.id) ?? [];
  const currentProfileLinks = Array.isArray(
    userDetails?.extraInformation?.profile
  )
    ? userDetails.extraInformation.profile
    : [];

  const defaultRelevantProfiles =
    userDetails?.extraInformation?.profile &&
    userDetails?.extraInformation?.profile.length > 0
      ? userDetails?.extraInformation.profile.map((_, i) => i)
      : [0];

  const [t] = useTranslation();
  const { notifyError, notifySuccess } = useNotify();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditRelevantProfile, setIsEditRelevantProfile] = useState(false);
  const [relevantProfiles, setRelevantProfile] = useState(
    defaultRelevantProfiles
  );

  profileCompletionRef.relevant = {
    openEdit: setIsEditRelevantProfile,
    profile: userDetails?.extraInformation?.profile ?? [],
    sampleOfWork: currentSampleOfWorkIds,
  };

  const removeRelevantProfile = (index) => {
    setRelevantProfile(relevantProfiles.filter((_, i) => i !== index));
  };

  const onEditRelevantProfile = async (values) => {
    try {
      setIsLoading(true);
      const { vendorAdditionalInfo, newCreated, deleted } = values;
      const deletedIds = deleted?.map((el) => el.fileId) ?? [];

      const payload = {
        profileLinks: Array.isArray(vendorAdditionalInfo?.profile)
          ? vendorAdditionalInfo.profile.filter(Boolean)
          : currentProfileLinks.filter(Boolean),
        sampleOfWorks: {
          newCreated:
            newCreated
              ?.filter(
                (el) =>
                  !deletedIds.includes(el.fileId) &&
                  !currentSampleOfWorkIds.includes(el.fileId)
              )
              ?.map((el) => el.fileId) ?? [],
          deleted: deletedIds,
        },
      };

      await profileApi.updateRelevantProfile(userDetails?.vendorId, payload);

      const userData = await profileApi.getUserProfileByIdApi(userDetails?.id);
      dispatch(actions.setUserDetails(userData));

      setIsEditRelevantProfile(false);
      notifySuccess("Has been updated successfully");
      scrollIntoView("relevantProfileIdScrollId");
    } catch (err) {
      console.error(err);
      notifyError(err?.data?.error ?? err?.message ?? "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const resetOnUnmount = () => {};
  useEffect(() => {
    return () => {
      resetOnUnmount();
    };
  }, []);

  return {
    isEditRelevantProfile,
    setIsEditRelevantProfile,
    onEditRelevantProfile,
    isRelevantProfileLoading: isLoading,
    relevantProfiles,
    setRelevantProfile,
    removeRelevantProfile,
  };
}

export default useRelevantProfile;
